module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "center-panel",
    attrs: {
      "id": "page__stocks"
    }
  }, [_c('md-content', {
    attrs: {
      "md-theme": "white",
      "loading": _vm.progress
    }
  }, [_c('sort-table', {
    attrs: {
      "columns": _vm.tableColumns,
      "per-page": _vm.perPage,
      "total": _vm.stocksAmount,
      "table-id": "stocks",
      "refreshOnCreate": false,
      "link": ""
    },
    on: {
      "refresh": _vm.getStocks,
      "create": _vm.addStock
    },
    scopedSlots: _vm._u([{
      key: "responsibles",
      fn: function(scope) {
        return [_c('span', [_vm._v(" " + _vm._s((scope.item && scope.item.responsibles && scope.item.responsibles.length) ? scope.item.responsibles.length : 0) + " ")])]
      }
    }, {
      key: "actions",
      fn: function(scope) {
        return [_c('z-icon-button', {
          attrs: {
            "icon": ['fa', 'dolly'],
            "rounded": ""
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              $event.preventDefault();
              _vm.toTraking($event, scope.item.id)
            }
          }
        }), _vm._v(" "), _c('z-icon-button', {
          attrs: {
            "icon": ['fa', 'user'],
            "rounded": ""
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              $event.preventDefault();
              _vm.toWorkers(scope.item.id)
            }
          }
        }), _vm._v(" "), _c('z-icon-button', {
          attrs: {
            "icon": ['fa', 'trash'],
            "rounded": "",
            "danger-light": ""
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              $event.preventDefault();
              _vm.onRemove(scope.item.id)
            }
          }
        })]
      }
    }]),
    model: {
      value: (_vm.stocks),
      callback: function($$v) {
        _vm.stocks = $$v
      },
      expression: "stocks"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b2e23a6","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/stock/views/Stocks.vue
// module id = 1112
// module chunks = 0